module["exports"] = [
  "Sverige"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/default_country.js
// module id = 2723
// module chunks = 2